export default `
.mce-content-body * {
  color: #000 !important;
  font-size: 14px !important;
  font-family: 'Roboto', 'PingFang SC', 'microsoft yahei ui', 'microsoft yahei', 'sans-serif' !important;
  word-break: break-word !important;
}

.mce-content-body a[href] {
  color: #326ff0!important;
}

.mce-content-body ul {
  list-style: disc inside;
}

.mce-content-body ol {
  list-style: decimal inside;
}

/* .mce-content-body ul, ol, blockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, p, pre {
  padding: 0;
  margin: 0;
} */

.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
  line-height: 22px;
  font-weight: 400;
  font-style: normal !important;
  font-size: 14px;
  color: #bbbdcb !important;
}

html::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

html::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 9px;
}

html::-webkit-scrollbar-track {
  display: none;
}
`;
